<template>
    <div class="mb-10">
        <h1 class="mb-2">{{ __(title) }}</h1>

        <table class="table-stock">
            <thead>
            <tr>
                <th class="text-uppercase">{{ __('Üzlet') }}</th>
                <th class="text-uppercase">{{ __('Státusz') }}</th>
                <th class="text-uppercase">{{ __('Telefon') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loading">
                <td colspan="3" class="text-center">
                    <div class="stock-modal-table-loading"><div></div><div></div><div></div><div></div></div>
                    <div>
                        {{ __('Kis türelmet, az adatok lekérdezése folyamatban!') }}
                    </div>
                </td>
            </tr>

            <tr v-for="store in items">
                <td>{{ store.name }}</td>
                <td>
                <span :class="[ store.isInStock ? 'available' : 'unavailable' ]">
                   {{ __(store.isInStock ? 'raktáron van' : 'nincs raktáron') }}
                </span>
                </td>
                <td>{{ store.phone }}</td>
            </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
export default {
    name: 'StockModalTable',

    props: {
        items: {
            type: Array,
            required: false,
        },

        loading: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
div.stock-modal-table-loading {
    display: inline-block;
    position: relative;
    width: 35px;
    height: 35px;

    div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 26px;
        height: 26px;
        margin: 4px;
        border: 4px solid;
        border-radius: 50%;
        animation: loading-keyframe 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #b7d630 transparent transparent transparent;

        &:nth-child(1) {
            animation-delay: -0.45s;
        }

        &:nth-child(2) {
            animation-delay: -0.3s;
        }

        &:nth-child(3) {
            animation-delay: -0.15s;
        }

        @keyframes loading-keyframe {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
}
</style>
